export const AUTH_TOKEN = 'auth-token'
export const API_URL = 'https://api-salvus.sandbox.sceme.io'
export const PLATFORM = 'staging'
export const ETH_CHAIN_ID = 11155111
export const MATIC_CHAIN_ID = 11155111
export const AVAX_CHAIN_ID = 43114
export const RECAPTCHA_KEY = '84047ffc-d8fc-4de2-b046-2840ff2a58d4'
export const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})");
export const safe_client_url = "https://safe-client.safe.global/"
